module.exports = "<div class=\"modal-header\">\r\n    <h4 class=\"modal-title\" id=\"myModalLabel\">Document Viewer</h4>\r\n</div>\r\n<div class=\"modal-body\" style=\"text-align: center;\">\r\n    <div id=\"report\">\r\n        <div id=\"rptFrame\"></div>\r\n    </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"viewerVm.close()\"><i class=\"fa fa-ban\"></i>Close</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/reports/previewer.html
// module id = 197
// module chunks = 0